/*
 * @Author: 熊望
 * @Date: 2021-03-17 20:10:17
 * @LastEditors: 熊望
 * @LastEditTime: 2021-03-23 14:55:18
 * @FilePath: /zxy-student-frontend/vue/src/modules/knowledge-operation/router.js
 * @Description:
 */
import shareTeamRouter from './share-team/shareTeamRouter';
import shareOutputRouter from './share-output/shareOutputRouter';

const shareRouter = () => {
    return [
        {
            path: 'share-content-detail/:id?',
            name: '纷享内容详情页',
            component: () => import(/* webpackChunkName: "share-index" */ './share-study/share-content-detail.vue'),
        },
        {
            path: 'share-study',
            component: () => import(/* webpackChunkName: "share-study" */ './share-study/index.vue'),
            children: [
                {
                    path: '/',
                    redirect: 'share-index',
                },
                {
                    path: 'share-index',
                    name: '纷享学习主页',
                    component: () => import(/* webpackChunkName: "share-index" */ './share-study/share-index.vue'),
                },
                {
                    path: 'my-collection-detail',
                    name: '关注/讨论/收藏详情页',
                    component: () => import(/* webpackChunkName: "my-collection-detail" */ './share-study/my-collection-detail.vue'),
                    meta: {
                        keepAlive: true,
                    },
                },
                {
                    path: 'certification-acount',
                    name: '纷享号认证页',
                    component: () => import(/* webpackChunkName: "certification-acount" */ './share-study/certification-acount.vue'),
                },
                {
                    path: 'certification-info',
                    name: '纷享号认证信息填写页',
                    component: () => import(/* webpackChunkName: "certification-info" */ './share-study/certification-info.vue'),
                },
                {
                    path: 'topic-list/:id?',
                    name: '话题内容列表',
                    component: () => import(/* webpackChunkName: "topic-list" */ './share-study/topic-list.vue'),
                },
            ],
        },
        ...shareTeamRouter,
        ...shareOutputRouter
    ];
};
export default shareRouter;
